module.exports = __webpack_public_path__ + "img/icon-rename.c840ad21.svg";